import React, { useContext, useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { ThemeContext } from "../../../context/ThemeContext";
import { Table, Pagination } from "rsuite";
import { SkipToken } from "@reduxjs/toolkit/dist/query";
import useTitle from "../../../hooks/useTitle";

import { useGetUserListQuery } from "../../../features/ac/acUserRoleApi";
import { useGetAcBranchListQuery } from "../../../features/ac/acBranchCreate";

import { useUpdateUserRoleMutation } from "../../../features/ac/acUserRoleApi";

import { useGetAcBranchAssignListQuery } from "../../../features/ac/acUserBranchAssignApi";
import { useCreateAcBranchAssignMutation } from "../../../features/ac/acUserBranchAssignApi";
import { useUpdateAcBranchAssignMutation } from "../../../features/ac/acUserBranchAssignApi";

import Select from "react-select";
import makeAnimated from "react-select/animated";
const animatedComponents = makeAnimated();

const { Column, HeaderCell, Cell } = Table;

function UserBranchAssign() {
  useTitle("User Branch Assign");
  const [show, setShow] = useState(false);
  const [createFormSelector, setCreateFormSelector] = useState(true);
  const [updateFormData, setUpdateFormData] = useState({});
  const [reseponseMessage, setResponseMessage] = useState();

  const [selectedOptions, setSelectedOptions] = useState([]);

  const theme = useContext(ThemeContext);

  const { data: userList } = useGetUserListQuery();
  const { data: acBranchList } = useGetAcBranchListQuery();

  const { data: userBranchAssignList, isLoading } =
    useGetAcBranchAssignListQuery();

  const [createAcBranchAssign] = useCreateAcBranchAssignMutation();
  const [updateAcBranchAssign] = useUpdateAcBranchAssignMutation();

  // const [updateUserRole] = useUpdateUserRoleMutation();

  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  let defaultData = [];
  let data = [];
  let defaultSelected = [];
  //for multiple select branch
  const options = acBranchList?.data?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  //for multiple select branch

  if (!isLoading) {
    if (userBranchAssignList?.data) {
      defaultData = [...userBranchAssignList.data];
      // defaultData = defaultData?.map((alertInfo) => {
      //   const data = new Date(alertInfo.updated_at);
      //   const formattedDate = data.toLocaleString();
      //   return {
      //     ...alertInfo,
      //     updated_at: formattedDate,
      //   };
      // });
    }

    data = defaultData?.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  }

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };
  const handleEdit = (user_id) => {
    let formData =
      defaultData.find((object) => object.user_id == user_id) || {};
    const userBranches = formData?.branches;
    // console.info(userBranches);
    // console.log(options);
    defaultSelected = options.filter((option) =>
      userBranches.includes(option.label)
    );
    // console.log(JSON.stringify(defaultSelected));

    // const temp_form_data = defaultSelected.map((item) => item?.value);
    // setUpdateFormData((previousValue) => ({
    //   ...previousValue,
    //   ac_branch_id: temp_form_data,
    // }));
    // console.error(updateFormData);
    setSelectedOptions(defaultSelected);
    setUpdateFormData(formData);
  };
  const handleModalOutsideClick = () => {
    setShow(false);
    setResponseMessage("");
  };
  const dataChangeHandler = (e) => {
    setResponseMessage("");
    setUpdateFormData((previousValue) => ({
      ...previousValue,
      [e.target.name]: e.target.value,
    }));
  };
  const branchChangeHandler = (e) => {
    const value = e.map((option) => option.value);

    setUpdateFormData((previousValue) => ({
      ...previousValue,
      ac_branch_id: value,
    }));
    // console.log(updateFormData);
  };

  const formSubmitHandler = (e) => {
    e.preventDefault();
    // console.log(updateFormData);
    if (createFormSelector) {
      createAcBranchAssign(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    } else {
      updateAcBranchAssign(updateFormData)
        .unwrap()
        .then((payload) => setResponseMessage(payload?.message))
        .catch((error) => setResponseMessage(error?.status));
    }
  };
  const handleClose = () => {
    setShow(false);
  };

  const handleChange = (selected) => {
    // console.log(selected);
    setSelectedOptions(selected);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#f0f0f0", // Change to your desired background color for the dropdown
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#f0f0f0", // Same background color for consistency
      color: "#333", // Change text color
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#4CAF50"
        : state.isFocused
        ? "#c8e6c9"
        : "#f0f0f0", // Different background when focused or selected
      color: state.isSelected ? "#FFFFFF" : "#333", // Text color based on selected state
      ":active": {
        backgroundColor: "#4CAF50", // Active background color
        color: "#FFFFFF",
      },
    }),
  };

  return (
    <div className={`row row-sm ${theme} `}>
      <div
        className="theme-text"
        style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "1rem" }}
      >
        User Branch Assign
      </div>
      <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <button
          type="submit"
          className="btn btn-primary btn-md "
          onClick={() => {
            setShow(true);
            setCreateFormSelector(true);
            setUpdateFormData({});
            setSelectedOptions([]);
          }}
        >
          Create User Assign
        </button>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        classname={`${theme} `}
        centered
        onExited={handleModalOutsideClick}
      >
        <div className={`${theme}`}>
          <Modal.Header
            className="theme-background theme-text"
            style={{ borderRadius: "0px" }}
          >
            <Modal.Title>
              {createFormSelector ? "Create User Assign" : "Update User Assign"}
            </Modal.Title>
            <div style={{ color: "green" }}>{reseponseMessage}</div>
            <RxCross2 onClick={handleModalOutsideClick} />
          </Modal.Header>
          <Modal.Body className="theme-background theme-text">
            {" "}
            <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12 zero-padding">
              <div>
                <div>
                  <form onSubmit={formSubmitHandler}>
                    {/* <div className="form-group">
                      <label for="sensorName">
                        User Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Company Name"
                        // value={name}
                        defaultValue={updateFormData?.name || ""}
                        name="name"
                        onChange={(e) => {
                          // setSensorName(e.target.value);
                          dataChangeHandler(e);
                        }}
                        readOnly
                        required
                      />
                    </div> */}
                    <div class="form-group">
                      <label class="form-label" for="premises no">
                        Select User <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        required
                        name="user_id"
                        class="form-control form-select"
                        onChange={(e) => {
                          dataChangeHandler(e);
                        }}
                        defaultValue={updateFormData?.user_id || ""}
                        disabled={!createFormSelector}
                      >
                        <option label="Choose one"></option>
                        {userList?.data?.map((userInfo) => {
                          return (
                            <option value={userInfo?.id}>
                              {userInfo?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Select Branch <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        // defaultValue={[options[4], options[5]]}
                        isMulti
                        value={selectedOptions}
                        options={options}
                        name="ac_branch_id[]"
                        onChange={(e) => {
                          branchChangeHandler(e);
                          handleChange(e);
                        }}
                        required
                        styles={customStyles}
                      />
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <Button type="submit">Submit</Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
      <div>
        <div className="table-responsive theme-background theme-text">
          <Table
            height={500}
            data={data || []}
            loading={defaultData.length > 0 ? false : true}
          >
            <Column
              width={100}
              align="center"
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>User Id</HeaderCell>
              <Cell dataKey="user_id" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>User Name</HeaderCell>
              <Cell dataKey="user_name" />
            </Column>

            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>User Role</HeaderCell>
              <Cell dataKey="user_role" />
            </Column>
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
              fullText
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Branch</HeaderCell>
              <Cell>{(rowData) => rowData.branches.join(", ")}</Cell>
            </Column>

            {/* <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Last Updated</HeaderCell>
              <Cell dataKey="updated_at" />
            </Column> */}
            <Column
              width={200}
              align="center"
              flexGrow={1}
              className={`theme-text theme-table-background`}
            >
              <HeaderCell style={{ color: "#6C88AF" }}>Edit</HeaderCell>
              <Cell>
                {(rowData) => (
                  <div
                    icon="edit"
                    onClick={() => {
                      setShow(true);
                      setCreateFormSelector(false);
                      handleEdit(rowData?.user_id);
                    }}
                  >
                    <FaEdit />
                  </div>
                )}
              </Cell>
            </Column>
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData.length}
              limitOptions={[10, 30, 50]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserBranchAssign;
